<div class="confirmation-container text-center py-5">
    <h2 class="hub-gradient">{{ confirmationMessage }}</h2>
</div>
  